import { Component } from "ecsy";

export default class AssetComponent extends Component {
  public asset: string = "";

  public reset() {
    this.asset = "";
  }
}
